module.exports = __webpack_public_path__ + "static/media/sanofi-genzyme-logo.ad7f1c9e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pages/patient-hope/sanofi-genzyme-logo.png
// module id = 381
// module chunks = 0